import { render, staticRenderFns } from "./BatchUpdate.vue?vue&type=template&id=45f5c98c&scoped=true"
import script from "./BatchUpdate.vue?vue&type=script&lang=js"
export * from "./BatchUpdate.vue?vue&type=script&lang=js"
import style0 from "./BatchUpdate.vue?vue&type=style&index=0&id=45f5c98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5c98c",
  null
  
)

export default component.exports